/* eslint-disable i18next/no-literal-string */
import Text from '@ingka/text';
import Modal, { Theatre, ModalHeader } from '@ingka/modal';
import { Trans, useTranslation } from 'react-i18next';
import Hyperlink from '@ingka/hyperlink';
import styles from './FindImageInfoTheatre.module.scss';
import Step1 from './assets/step1.png';
import Step2 from './assets/step2.png';
import Step3 from './assets/step3.png';
import Step4 from './assets/step4.png';

export type FindImageInfoProps = {
  open: boolean;
  onClose: () => void;
};

export const FindImageInfoTheatre = (FindImageInfoProps: FindImageInfoProps) => {
  const { open, onClose } = FindImageInfoProps;
  const { t } = useTranslation();
  const xsUrl = 'https://www.ikea.com/ext/ingkadam/m/1cc7957989ddec60/original/PH182561.jpg?f=xs';
  const xlUrl = 'https://www.ikea.com/ext/ingkadam/m/1cc7957989ddec60/original/PH182561.jpg?f=xl';

  return (
    <Modal className={styles['modal']} visible={open} handleCloseBtn={onClose}>
      <Theatre header={<ModalHeader />}>
        <div className={styles['container']}>
          <div className={styles['header-div']}>
            <Text headingSize="m">{t('find-image-theatre-intro-title')}</Text>
            <Text bodySize="l">{t('find-image-theatre-intro-description')}</Text>
            <Text bodySize="l">
              <b>{'https://www.ikea.com/ext/ingkadam/...'}</b>
            </Text>
            &nbsp;
            <Text bodySize="l">{t('find-image-theatre-intro-step-by-step')}</Text>
          </div>
          <div className={styles['section']}>
            <div className={styles['header']}>
              <span className={styles['circle']} key={'circle-1'}>
                <Text className={styles['number']}>{1}</Text>
              </span>
              <Text bodySize="l" tagName="h3">
                {t('find-image-theatre-section-1-title')}
              </Text>
            </div>
            <Text bodySize="l" className={styles['text']}>
              {t('find-image-theatre-section-1-description-1')}
              &nbsp;
              <Hyperlink
                url="https://ikea.getbynder.com"
                text={'(https://ikea.getbynder.com).'}
                newWindow={true}
              />
              &nbsp;
              {t('find-image-theatre-section-1-description-2')}
            </Text>
            <img className={styles['img']} alt="Ingka DAM serach results" src={Step1} />
          </div>

          <div className={styles['section']}>
            <div className={styles['header']}>
              <span className={styles['circle']} key={'circle-1'}>
                <Text className={styles['number']}>{2}</Text>
              </span>
              <Text bodySize="l" tagName="h3">
                {t('find-image-theatre-section-2-title')}
              </Text>
            </div>
            <Text bodySize="l" className={styles['text']}>
              {t('find-image-theatre-section-2-description-1')}
              &nbsp;
              <Hyperlink
                url="https://ladan.ingka.com/assetstatus"
                text={'https://ladan.ingka.com/assetstatus'}
                newWindow={true}
              />
            </Text>
            <Text bodySize="l" className={styles['text']}>
              {t('find-image-theatre-section-2-description-2')}
            </Text>
            <img className={styles['img']} alt="The Barn assetstatus page" src={Step2} />
          </div>
          <div className={styles['section']}>
            <div className={styles['header']}>
              <span className={styles['circle']} key={'circle-1'}>
                <Text className={styles['number']}>{3}</Text>
              </span>
              <Text bodySize="l" tagName="h3">
                {t('find-image-theatre-section-3-title')}
              </Text>
            </div>
            <img
              className={styles['img']}
              alt="The Barn assetstatus page with results"
              src={Step3}
            />
          </div>
          <div className={styles['section']}>
            <div className={styles['header']}>
              <span className={styles['circle']} key={'circle-1'}>
                <Text className={styles['number']}>{4}</Text>
              </span>
              <Text bodySize="l" tagName="h3">
                {t('find-image-theatre-section-3-title')}
              </Text>
            </div>
            <Text bodySize="l" className={styles['text']}>
              {
                <Trans
                  i18nKey="find-image-theatre-section-4-description-1"
                  values={{
                    xsUrl,
                    xlUrl,
                  }}
                  shouldUnescape={true}
                />
              }
            </Text>
            &nbsp;
            <ol className={styles['text']}>
              <li>
                <Text bodySize="l">{t('find-image-theatre-section-4-description-2')}</Text>
              </li>
              <li>
                <Text bodySize="l">{t('find-image-theatre-section-4-description-3')}</Text>
              </li>
              <li>
                <Text bodySize="l">{t('find-image-theatre-section-4-description-4')}</Text>
              </li>
              <li>
                <Text bodySize="l">{t('find-image-theatre-section-4-description-5')}</Text>
              </li>
            </ol>
            <img className={styles['img']} alt="Sizes with different query params" src={Step4} />
          </div>
        </div>
      </Theatre>
    </Modal>
  );
};
